import axios from "utils/axios";
import { stringify } from "query-string";

export const getSuggestionAccount = (params) => {
  const query = stringify(params);
  return axios.get(
    `/hr/settings/connects/finance/accounts/suggestionPerPage?${query}`
  );
};
